<template>
  <div>
    <list
      row-key="GroupStudentId"
      ref="list"
      unit="学生列表"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="true"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学生编号">
          <el-input v-model="params.StudentNumber" placeholder="请输入学生编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="params.FullName" placeholder="请输入姓名" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="类型">
          <el-select v-model="params.PackageType" placeholder="请选择类型">
            <el-option :value="0" label="基础套餐"></el-option>
            <el-option :value="1" label="增值套餐"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收费金额">
          <el-input v-model="params.Amount" type="number" placeholder="请输入收费金额" clearable></el-input>
        </el-form-item> -->
      </template>
      <template slot="table">
        <el-table-column prop="StudentNumber" label="学生编号"/>
        <el-table-column prop="FullName" label="姓名"/>
        <!-- <el-table-column prop="PackageType" label="类型">
          <template slot-scope="{row}">
            {{row.PackageType==0?"基础套餐":"增值套餐"}}
          </template>
        </el-table-column>
        <el-table-column prop="Amount" label="收费金额"/>
        <el-table-column label="收费周期" min-width="150">
          <template slot-scope="{row}">
            <span>{{row.StartMonth + ' - ' + row.EndMonth}}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="TotalMonth" label="周期月数">
          <template slot-scope="{row}">
            {{datemonth(row.EndMonth,row.StartMonth)}}
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="每月赠送套餐外话费" min-width="130">
          <template slot-scope="{row}">
            <span v-if="row.PackageType==1">{{row.GiveCharge}}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="收费月份">
          <template slot-scope="{row}">
            <span v-if="row.PackageType==1">{{datemonth(row.EndMonth,row.StartMonth) - row.FreeMonth}}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="FreeMonth" label="赠送月份">
          <template slot-scope="{row}">
            {{ row.PackageType==0?"":row.FreeMonth }}
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="AddTime" label="开通时间" width="150" /> -->
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { 
    list,
  },
  props: {
    rowKey: {
      type: String,
      default: undefined,
    }
  },
  data() {
    return {
      api: require("@/api/st/groupStudent").default,
      params: {
        FullName: "",
        StudentNumber: "",
        GroupId: 0,
      },
    };
  },
  methods: {
    // datemonth(date1,date2) {
    //   // 拆分年月日
    //   date1 = date1.split('-');
    //   // 得到月数
    //   date1 = parseInt(date1[0]) * 12 + parseInt(date1[1]);
    //   // 拆分年月日
    //   date2 = date2.split('-');
    //   // 得到月数
    //   date2 = parseInt(date2[0]) * 12 + parseInt(date2[1]);
    //   var m = date1 - date2; //Math.abs()取绝对值
    //   return m + 1;
    // },
    export() {
      this.api.export(
        this.$commonJs.obj.removeNullKey({ ...this.$refs.list.tempQueryParams,...this.$refs.list.initParams, ExportType: 1})
      );
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  }
};
</script>
<style lang="scss" scoped>
</style>

